import React from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';
import { IsVerified } from './IsVerified';
import { DOCUMENT_STATUSES } from '../constants';
import { getUKFormattedDate } from '../utils/dates';

interface Props {
  verified: boolean;
  status: string;
  idExpiring?: {
    expired: boolean;
    expiring: boolean;
    expiring_date: string;
    status: string;
  };
}

export const IDStatus: React.FC<Props> = ({ verified, status, idExpiring }) => {
  const theme = useTheme();
  const showStatus: boolean = status !== DOCUMENT_STATUSES.VERIFIED;
  const formattedStatus =
    idExpiring?.expiring && idExpiring?.expiring_date
      ? `Exp. ${getUKFormattedDate(idExpiring.expiring_date)}`
      : status;

  return (
    <Box display="flex" alignItems="center">
      <IsVerified verified={verified} checkIconColor={showStatus ? theme.palette.warning.main : undefined} />
      {showStatus && (
        <Box marginLeft={1}>
          <Typography variant="caption" color="textSecondary">
            {formattedStatus}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
